import React from "react";

/**
 * PhotoFrame — a tall, editorial placeholder for real photos.
 *
 * If `src` is provided, it renders the image with a subtle hover zoom.
 * If not, it renders an elegant beige placeholder with a discreet label
 * so the layout looks intentional until the user inserts a real photo.
 */
const PhotoFrame = ({
  src,
  alt = "",
  ratio = "3/4",
  label,
  className = "",
  testId,
}) => {
  return (
    <div
      className={`relative overflow-hidden bg-[#F4EFE7] ${className}`}
      style={{ aspectRatio: ratio }}
      data-testid={testId}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out hover:scale-[1.03]"
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
          <div className="h-px w-10 bg-[#3F403A]/25" aria-hidden />
          <p className="font-serif text-2xl md:text-3xl mt-6 text-[#3F403A]/60 leading-tight">
            {label || "Fotografía"}
          </p>
          <p className="mt-3 overline text-[#3F403A]/40">Espacio para foto</p>
        </div>
      )}
      {/* thin inner frame */}
      <div className="pointer-events-none absolute inset-0 border border-[#3F403A]/8" />
    </div>
  );
};

export default PhotoFrame;
